<template>
    <div>
        <f-title :title="title" v-if="title" class="mt-0" />
        <div :class="border ? 'lm-border pa-2' : ''">
            <v-row class="no-frame mt-n1">
                <v-col class="no-frame pr-2 col-6">
                    <f-currency-field
                        v-model         = "data.priceOriginal"
                        class           = "money"
                        :label          = "$t('invoice.price.original')"
                        :readonly       = "readonly"
                        :rules          = "[originalPriceRule]"
                        :error-messages = "priceOriginalError"
                        hide-details=""
                    />
                    <f-currency-field
                        class         = "money mt-2"
                        :label        = "$t('invoice.cost.material')"
                        :readonly     = "readonly"
                        v-model       = "data.costMaterial"
                        :rules        = "[costPriceRule]"
                        :error-messages = "costMaterialError"
                        hide-details=""
                    />
                    <f-currency-field
                        v-model       = "data.costWage"
                        class         = "money mt-2"
                        :label        = "$t('invoice.cost.wage')"
                        :readonly     = "readonly"
                        :rules        = "[costPriceRule]"
                        :error-messages = "costWageError"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-2 col-6">
                    <f-currency-field
                        v-model   = "data.priceRecommended"
                        class     = "money"
                        :label    = "$t('invoice.price.recommended')"
                        :readonly = "readonly"
                        :rules    = "[recomendationRule]"
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame mt-5" >
                <v-col class="no-frame">
                    <v-textarea
                        v-model="data.notice"
                        :rules    = "[requiredOnTerminationRule]"
                        rows      = "3"
                        :label    = "$t('repair.bid.label.measure')"
                        :readonly = "readonly"
                        :disabled = "readonly"
                        no-resize
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";
import FCurrencyField   from "@/modules/core/components/utils/FCurrencyField.vue";
import FTitle from "@/modules/core/components/utils/FTitle.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "IncCalculation",

    components: {
        FTitle,
        FCurrencyField,
    },

    props: {
        data: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    priceOriginal   : null,
                    priceRecommended: null,
                    costMaterial    : null,
                    costWage        : null
                }
            }
        },

        status: {
            required: true,
            type    : Object,

        },

        favorite: {
            required: true,
            type    : Boolean,
        },

        title: {
            required: false,
            type: String,
            default: function () {
                return null;
            }
        },

        form: {
            required: true,
            type    : Object
        },

        notice: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        border: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        readonly: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
   },

    data: () => ({
        priceOriginalError: [],
        costMaterialError : [],
        costWageError     : [],
    }),

    watch: {
        data: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    this.form.validate();
                });
            }
        },
    },

    computed: {
        sum () {
            if (this.bid === null) {
                return "";
            }

            const sum = this.round(this.bid.costMaterial) + this.round(this.bid.costWage);
            if (Number.isNaN(sum) === true) {
                return "";
            }

            return Core.format.money (sum);
        },

        costPriceRule () {
            return this.validateCostsAgainstPrice;
        },
    },

    methods: {
        recomendationRule () {
            if (Inc.step.canceled(this.status)) {
                return true;
            }

            if (!this.data.priceOriginal && this.data.priceRecommended) {
                return "Angebotspreis (Ursprung) fehlt"
            }

            if (this.round(this.data.priceRecommended) && this.round(this.data.priceRecommended) > this.round(this.data.priceOriginal)) {
                return "Empfehlung größer als Ursprung"
            }

            return true;
        },

        requiredOnTerminationRule (value)  {
            if (Inc.step.canceled(this.status)) {
                return true;
            }

            if (!this.favorite) {
                return true;
            }

            return Core.rule.requiredOnTermination(value, this.status);
        },

        originalPriceRule (value) {
            if (Inc.step.canceled(this.status)) {
                return true;
            }

            if (this.favorite) {
                if ((!value || value.length === 0) && this.status.type === 'T') {
                    this.priceOriginalError = [this.$t("rules.required")];
                    this.costMaterialError = [];
                    this.costWageError = [];

                    return false;
                }
            }

            return this.validateCostsAgainstPrice();
        },

        validateCostsAgainstPrice ()  {
            if (Inc.step.canceled(this.bistatus)) {
                return true;
            }

            if ((!this.data.priceOriginal || this.data.priceOriginal === 0) && (this.data.costMaterial || this.data.costWage)) {
                return this.setError("inc.bid.error.cost-without-price");
            }

            if (this.data.priceOriginal !== 0) {
                const sum = this.round(this.data.costMaterial + this.data.costWage);
                if (sum !== 0 && sum !==  this.round(this.data.priceOriginal)) {
                    return this.setError("inc.bid.error.cost-price-difference");
                }
            }

            return this.clearError();
        },

        setError (text) {
            this.priceOriginalError = [this.$t(text)];
            this.costMaterialError  = [""];
            this.costWageError      = [""];
            return false;
        },

        clearError () {
            this.priceOriginalError = [];
            this.costMaterialError  = [];
            this.costWageError      = [];
            return true;
        },

        round (value) {
            return (Math.round(value * 100)/100);
        }

    }
}
</script>

<style scoped>

.money ::v-deep input{
    text-align: right;
}

.price-background {
    padding-bottom: 8px;
    padding-left: 5px;
    background-color: #f5f5f5;
}

</style>